module.exports = __webpack_public_path__ + "img/message-template-icon.63592e5a.svg";